import Vue from 'vue';
import Vuetify, { VLayout } from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';

Vue.use(Vuetify, {
  iconfont: 'md',
  components: {
    VLayout,
  },
  theme: {
    primary: '#8BC34A',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#8BC34A',
    warning: '#FFC107',
  },
});
